import React from 'react';

import Content from './Content';

const Map = props => {
  return <Content {...props} />;
};

export default Map;
